/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Input from 'components/inputs/Input/Input';
import InputPhone from 'components/inputs/InputPhone/InputPhone';
import Button2 from 'components/buttons/Button2/Button2';
import { getPhoneCode } from 'libphonenumber-js';
import withTitle from 'hocs/WithTitle';
import _unset from 'lodash/unset';
import { hashHistory } from 'react-router';
import queryString from 'query-string';
import styles from './style.cssmodule.css';
import { useSignUp } from './useSignUp';

const SignUp = ({
  query,
  query: { link },
  handleFormTypeChange,
  pathname,
}) => {
  const { formatMessage: t } = useIntl();

  const {
    fields,
    changeField,
    errors,
    submitStatus,
    isSubmitting,
    handleSubmit,
  } = useSignUp({
    link,
    handleFormTypeChange,
  });

  // ✅ Account created !
  const removeLinkFromUrl = () => {
    _unset(query, 'link');
    hashHistory.replace({
      pathname,
      search: `?${queryString.stringify(query, { encode: true })}`,
    });
  };

  if (submitStatus === 'success') {
    if (link) removeLinkFromUrl();
  }

  return (
    <form>
      <div className={styles.inputGrid}>
        <Input
          label={t({ id: 'field.firstname' })}
          type="text"
          name="firstname"
          autoComplete="given-name"
          disabled={isSubmitting}
          value={fields.firstname}
          error={errors.firstname}
          onChange={({ target: { value: newFirstname } }) => changeField({ name: 'firstname', value: newFirstname })}
        />
        <Input
          label={t({ id: 'field.lastname' })}
          type="text"
          name="lastname"
          autoComplete="family-name"
          disabled={isSubmitting}
          value={fields.lastname}
          error={errors.lastname}
          onChange={({ target: { value: newLastname } }) => changeField({ name: 'lastname', value: newLastname })}
        />
        <Input
          label={t({ id: 'field.emailExplicit' })}
          type="email"
          name="email"
          autoComplete="email"
          disabled={isSubmitting}
          value={fields.email}
          error={errors.email}
          onChange={({ target: { value: newEmail } }) => changeField({ name: 'email', value: newEmail })}
        />
        <InputPhone
          label={t({ id: 'field.phoneNumber' })}
          name="tel"
          disabled={isSubmitting}
          countryCode={fields.countryCode}
          changeCountryCode={(newCountryCode) => {
            changeField({ name: 'countryCode', value: newCountryCode });
            changeField({ name: 'phone', value: `+${getPhoneCode(newCountryCode)}${fields.phoneWithoutPrefix}` });
          }}
          error={errors.phone}
          value={fields.phoneWithoutPrefix}
          onChange={({ target: { value: newPhoneWithoutPrefix } }) => {
            changeField({ name: 'phoneWithoutPrefix', value: newPhoneWithoutPrefix });
            changeField({ name: 'phone', value: `+${getPhoneCode(fields.countryCode)}${newPhoneWithoutPrefix}` });
          }}
        />
        <Input
          label={t({ id: 'field.password' })}
          type="password"
          name="password"
          autoComplete="new-password"
          disabled={isSubmitting}
          value={fields.password}
          error={errors.password}
          onChange={({ target: { value: newPassword } }) => changeField({ name: 'password', value: newPassword })}
        />
        <Input
          label={t({ id: 'field.passwordConfirmation' })}
          type="password"
          name="passwordConfirmation"
          autoComplete="new-password"
          disabled={isSubmitting}
          value={fields.passwordConfirmation}
          error={errors.passwordConfirmation}
          onChange={({ target: { value: newpasswordConfirmation } }) => changeField({ name: 'passwordConfirmation', value: newpasswordConfirmation })}
        />
      </div>
      <Button2
        onClick={handleSubmit}
        loading={isSubmitting}
        disabled={isSubmitting}
        type="primary"
        className={styles.signUpButton}
        size="medium"
      >
        {t({ id: 'button.createAccount' })}
      </Button2>
    </form>
  );
};

SignUp.propTypes = {
  pathname: PropTypes.string,
  query: PropTypes.shape({
    link: PropTypes.string,
  }),
  handleFormTypeChange: PropTypes.func,
};

SignUp.defaultProps = {
  pathname: null,
  query: {
    link: null,
  },
  handleFormTypeChange: () => {},
};

module.exports = withTitle('pageTitle.signup')(SignUp);



// WEBPACK FOOTER //
// ./routes/login/components/cpm_client/components/SignUp/SignUp.jsx